import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gs-ga-creation-grid',
  templateUrl: './gs-ga-creation-grid.component.html',
  styleUrls: ['./gs-ga-creation-grid.component.css']
})
export class GsGaCreationGridComponent implements OnInit {
  title="GS-GA Creation List"
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/accountmaster/gs-ga-creation-grid/gs-ga-creation-grid.component.ts